// Wave X-5 (2026-05-13) — 자관법 동의 admin 대시보드 UI
// 통계 카드 + 누락 차량 리스트 + D-day 카운트다운

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function AdminOwnerConsent({ showToast, th, td, btnStyle }) {
  var [overview, setOverview] = useState(null);
  var [items, setItems] = useState([]);
  var [kind, setKind] = useState('public');
  var [loading, setLoading] = useState(false);
  var [listLoading, setListLoading] = useState(false);

  function fetchOverview() {
    setLoading(true);
    authFetch(API + '/admin/owner-consent-overview')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) setOverview(d.data);
        else showToast && showToast((d && d.error) || '조회 실패', 'error');
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setLoading(false); });
  }

  function fetchList() {
    setListLoading(true);
    authFetch(API + '/admin/cars-missing-consent?kind=' + encodeURIComponent(kind) + '&limit=100')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) setItems((d.data && d.data.items) || []);
        else showToast && showToast((d && d.error) || '조회 실패', 'error');
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setListLoading(false); });
  }

  useEffect(function() { fetchOverview(); }, []);
  useEffect(function() { fetchList(); }, [kind]);

  function ddayBadge(daysUntil, isEnforced) {
    if (isEnforced) {
      return <span style={{ padding: '6px 14px', background: '#dc2626', color: '#fff', borderRadius: 6, fontSize: 13, fontWeight: 700 }}>⚖️ 법 시행 중</span>;
    }
    if (daysUntil == null) return null;
    var bg = daysUntil <= 7 ? '#dc2626' : daysUntil <= 14 ? '#f59e0b' : '#1B3A5C';
    return <span style={{ padding: '6px 14px', background: bg, color: '#fff', borderRadius: 6, fontSize: 13, fontWeight: 700 }}>D-{daysUntil}</span>;
  }

  function goCarPage(carId) {
    // 차량 페이지로 이동 — 새 탭
    window.open('/main/car-list?focus=' + carId, '_blank');
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1B3A5C' }}>🚗 자동차관리법 동의</h3>
        {overview && ddayBadge(overview.daysUntil, overview.isEnforced)}
        {overview && (
          <span style={{ fontSize: 12, color: '#64748b' }}>
            시행일 {overview.enforcementDate}
          </span>
        )}
        <button onClick={function() { fetchOverview(); fetchList(); }} style={Object.assign({}, btnStyle, { padding: '6px 14px', marginLeft: 'auto' })}>
          새로고침
        </button>
      </div>

      {loading ? (
        <div style={{ fontSize: 13, color: '#94a3b8' }}>불러오는 중...</div>
      ) : overview && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 24 }}>
          <StatCard label="전체 차량" value={overview.total} color="#1B3A5C" />
          <StatCard label="동의 완료" value={overview.given} color="#16a34a" suffix={overview.total ? '(' + Math.round((overview.given / overview.total) * 100) + '%)' : ''} />
          <StatCard label="동의 누락" value={overview.missing} color={overview.missing > 0 ? '#dc2626' : '#64748b'} suffix={overview.total ? '(' + Math.round((overview.missing / overview.total) * 100) + '%)' : ''} />
          <StatCard label="공개중 누락" value={overview.publicMissing} color={overview.publicMissing > 0 ? '#dc2626' : '#64748b'} urgent={overview.publicMissing > 0} />
          <StatCard label="출품중 누락" value={overview.listedMissing} color={overview.listedMissing > 0 ? '#dc2626' : '#64748b'} urgent={overview.listedMissing > 0} />
          <StatCard label="레거시 누락" value={overview.legacyMissing} color={overview.legacyMissing > 0 ? '#f59e0b' : '#64748b'} hint="시행일 이전 등록" />
        </div>
      )}

      {/* 안내 박스 */}
      {overview && !overview.isEnforced && (overview.publicMissing > 0 || overview.listedMissing > 0) && (
        <div style={{ padding: 12, background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: 6, fontSize: 13, color: '#78350f', marginBottom: 16 }}>
          ⚠️ 법 시행일({overview.enforcementDate}) 이후 동의 누락 차량은 자동으로 공개/출품 차단됩니다.
          시행 전 동의를 받지 못한 차량은 시행일에 일괄 비공개됩니다 — 미리 처리하세요.
        </div>
      )}
      {overview && overview.isEnforced && overview.missing > 0 && (
        <div style={{ padding: 12, background: '#fee2e2', border: '1px solid #dc2626', borderRadius: 6, fontSize: 13, color: '#7f1d1d', marginBottom: 16 }}>
          🚨 법 시행 중 — 동의 누락 차량은 광고/출품/외부 노출 모두 차단됩니다.
        </div>
      )}

      {/* 차량 리스트 */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
        <FilterBtn active={kind === 'public'} onClick={function() { setKind('public'); }}>
          공개중 ({overview ? overview.publicMissing : 0})
        </FilterBtn>
        <FilterBtn active={kind === 'listed'} onClick={function() { setKind('listed'); }}>
          출품중 ({overview ? overview.listedMissing : 0})
        </FilterBtn>
        <FilterBtn active={kind === 'legacy'} onClick={function() { setKind('legacy'); }}>
          레거시 ({overview ? overview.legacyMissing : 0})
        </FilterBtn>
        <FilterBtn active={kind === 'all'} onClick={function() { setKind('all'); }}>
          전체 ({overview ? overview.missing : 0})
        </FilterBtn>
      </div>

      {listLoading ? (
        <div style={{ fontSize: 13, color: '#94a3b8' }}>불러오는 중...</div>
      ) : items.length === 0 ? (
        <div style={{ fontSize: 13, color: '#94a3b8', padding: 20, textAlign: 'center', background: '#f8fafc', borderRadius: 8 }}>
          {kind === 'public' ? '공개중 동의 누락 차량 없음 ✨' :
           kind === 'listed' ? '출품중 동의 누락 차량 없음 ✨' :
           kind === 'legacy' ? '레거시 동의 누락 차량 없음' :
           '동의 누락 차량 없음'}
        </div>
      ) : (
        <div style={{ overflowX: 'auto', maxHeight: 500 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>ID</th>
                <th style={th}>차량번호</th>
                <th style={th}>제조/모델/연식</th>
                <th style={th}>업체</th>
                <th style={th}>등록일</th>
                <th style={th}>상태</th>
                <th style={th}>이동</th>
              </tr>
            </thead>
            <tbody>
              {items.map(function(c) {
                var legacy = c.registered_at && c.registered_at < (overview ? overview.enforcementDate : '2026-06-03');
                return (
                  <tr key={c.id}>
                    <td style={td}>{c.id}</td>
                    <td style={Object.assign({}, td, { fontWeight: 600 })}>{c.carNo || '-'}</td>
                    <td style={td}>
                      {c.maker || '-'} {c.model_name || ''} {c.year ? '(' + c.year + ')' : ''}
                    </td>
                    <td style={td}>{c.company_name || '-'}</td>
                    <td style={td}>
                      {c.registered_at || '-'}
                      {legacy && <span style={{ marginLeft: 6, fontSize: 11, color: '#f59e0b' }}>레거시</span>}
                    </td>
                    <td style={td}>
                      {c.isPublic === 1 && <span style={{ padding: '2px 8px', background: '#dcfce7', color: '#166534', borderRadius: 10, fontSize: 11, fontWeight: 600, marginRight: 4 }}>공개중</span>}
                      {c.active_auctions > 0 && <span style={{ padding: '2px 8px', background: '#fef3c7', color: '#92400e', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>출품중 {c.active_auctions}</span>}
                      {c.isPublic !== 1 && (c.active_auctions == null || c.active_auctions === 0) && <span style={{ fontSize: 11, color: '#94a3b8' }}>대기</span>}
                    </td>
                    <td style={td}>
                      <button onClick={function() { goCarPage(c.id); }} style={{ padding: '4px 10px', fontSize: 11, background: '#1B3A5C', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                        🔍 열기
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ marginTop: 16, padding: 12, background: '#f8fafc', borderRadius: 6, fontSize: 12, color: '#64748b' }}>
        💡 동의는 차량 페이지(차량관리 → 차량 클릭) 에서 처리할 수 있습니다.
        시행일 이전 등록 차량은 시행일 이후 광고/출품 시점에 재동의 필요 (legacy_consent_required).
      </div>
    </div>
  );
}

function StatCard({ label, value, color, suffix, urgent, hint }) {
  return (
    <div style={{ padding: 14, background: '#fff', border: '1px solid ' + (urgent ? '#dc2626' : '#e5e7eb'), borderRadius: 8, boxShadow: urgent ? '0 0 0 2px rgba(220,38,38,0.1)' : 'none' }}>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 800, color: color }}>{value != null ? value : '-'}</div>
      {suffix && <div style={{ fontSize: 11, color: '#94a3b8' }}>{suffix}</div>}
      {hint && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

function FilterBtn({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '6px 12px',
        fontSize: 12,
        fontWeight: 600,
        background: active ? '#1B3A5C' : '#f1f5f9',
        color: active ? '#fff' : '#64748b',
        border: 'none',
        borderRadius: 6,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default AdminOwnerConsent;
